import { PdpDataType } from "@/layouts/PdpLayout";
import { createContext, useContext } from "react";

type PdpCtxType = {
  pdpData: PdpDataType;
  setPdpData: (data: PdpDataType) => void;
  lensSelectionTabIndex: number;
  setLensSelectionTabIndex: (index: number) => void;
};

export const PdpCtx = createContext<null | PdpCtxType>(null);

export function usePdpContext() {
  const ctx = useContext(PdpCtx);
  if (ctx === null) throw new Error("Pdp context must be used inside a Pdp context");
  return ctx;
}
